module.exports = __webpack_public_path__ + "static/media/signal-3.99c0c1d0.svg";